import { OnboardingMode } from '../onboarding/steps/types.d'
import { DuplicationCheck, OnboardingContactInformationSchema } from '@cbgms/api'
import {
  useDuplicateCheckShopAddress,
  useDuplicateCheckShopEmail,
  useDuplicateCheckShopPhoneNumber
} from 'app/auth/components/hooks/use-duplicate-checks'

export const useContactValidatorBuilder = (basePath: string, _: OnboardingMode, duplicationChecks: DuplicationCheck[]) => {
  const handleDuplicateCheckPhoneNumber = useDuplicateCheckShopPhoneNumber(duplicationChecks, basePath)
  const handleDuplicateCheckAddress = useDuplicateCheckShopAddress(duplicationChecks, basePath)
  const handleDuplicateCheckEmail = useDuplicateCheckShopEmail(duplicationChecks, basePath)

  return async (data: OnboardingContactInformationSchema) => {
    await handleDuplicateCheckEmail(data.EmailAddress)
    await handleDuplicateCheckPhoneNumber(data.PhoneNumber?.toString())
    await handleDuplicateCheckAddress({
      City: data.VisitorCity,
      Street: data.VisitorAddress,
      HouseNumber: data.VisitorHouseNumber?.toString()
    })
  }
}
